import React from "react";
import SvgIcon from "../../../../parts/SvgIcon";

function NotesWrapper({
  openQuickEditMode,
  onInputHandleQuickEditChange,
  activeExercise,
  notesInputRef,
}) {
  if (!openQuickEditMode && !activeExercise.notes) return null;
  return (
    <div className="exnotes">
      <SvgIcon src="/img/new-icons/message-icon.svg" />
      {openQuickEditMode ? (
        <textarea
          ref={notesInputRef}
          id={`${activeExercise._id}_notes`}
          name="notes"
          defaultValue={activeExercise.notes ? activeExercise.notes : ""}
          onInput={onInputHandleQuickEditChange}
          className="textarea-input-notes"
          placeholder="Enter notes here"
        />
      ) : (
        <p className="p2">{activeExercise.notes}</p>
      )}
    </div>
  );
}

export default NotesWrapper;
